import { render, staticRenderFns } from "./MiniStackVanila.vue?vue&type=template&id=0d39899d&scoped=true&"
import script from "./MiniStackVanila.vue?vue&type=script&lang=js&"
export * from "./MiniStackVanila.vue?vue&type=script&lang=js&"
import style0 from "./MiniStackVanila.vue?vue&type=style&index=0&id=0d39899d&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d39899d",
  null
  
)

export default component.exports